/*
  CDS — Filet de sécurité des animations d'entrée.

  Problème : les sections CDS démarrent en opacity: 0 (classe X--has-animation)
  et sont révélées par IntersectionObserver (classe X--animated). Dans certains
  navigateurs intégrés (Instagram/Facebook in-app), l'observer ne se déclenche
  jamais ou un script injecté plante → les sections restent invisibles
  → « page beige ».

  Solution : toutes les 700 ms, on vérifie chaque élément encore masqué ;
  s'il est dans la zone visible de l'écran, on le révèle nous-mêmes.
  - Si tout fonctionne normalement, l'observer natif révèle avant nous → no-op,
    les animations au scroll sont conservées à l'identique.
  - À la moindre erreur JS globale, on révèle tout immédiatement.

  100% ES5 : fonctionne aussi dans les WebViews anciennes.
*/
(function () {
  if (window.__cdsAnimFailsafe) return;
  window.__cdsAnimFailsafe = true;

  function inViewport(el, margin) {
    try {
      var r = el.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.top < h + margin && r.bottom > -margin && (r.width > 0 || r.height > 0);
    } catch (e) { return true; }
  }

  /* Révèle un élément porteur du pattern X--has-animation → ajoute X--animated */
  function revealSection(el) {
    var classes = (el.className || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      var idx = classes[i].indexOf('--has-animation');
      if (idx > -1) {
        el.classList.add(classes[i].slice(0, idx) + '--animated');
      }
    }
  }

  function sweep(force) {
    var done = true;
    var sections = document.querySelectorAll('[class*="--has-animation"]');
    var i;
    for (i = 0; i < sections.length; i++) {
      var el = sections[i];
      /* Déjà révélé ? (une classe --animated correspondante existe) */
      if ((el.className || '').indexOf('--animated') > -1) continue;
      if (force || inViewport(el, 120)) revealSection(el);
      else done = false;
    }
    /* Fiche produit : colonne d'infos animée élément par élément (is-visible) */
    var info = document.querySelectorAll('.cds-pp__info > *');
    for (i = 0; i < info.length; i++) {
      var it = info[i];
      if (it.classList.contains('is-visible')) continue;
      if (force || inViewport(it, 120)) it.classList.add('is-visible');
      else done = false;
    }
    return done;
  }

  var timer = null;
  function start() {
    /* Première passe après 1,8 s : laisse les animations normales se jouer d'abord */
    setTimeout(function () {
      if (sweep(false)) return;
      timer = setInterval(function () {
        if (sweep(false) && timer) { clearInterval(timer); timer = null; }
      }, 700);
      /* On n'observe pas indéfiniment : arrêt au bout de 60 s */
      setTimeout(function () { if (timer) { clearInterval(timer); timer = null; } }, 60000);
    }, 1800);
  }

  /* Erreur JS quelque part ? On ne prend aucun risque : tout est révélé. */
  window.addEventListener('error', function () {
    try { sweep(true); } catch (e) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
